import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue';
import NotFound from '../views/NotFound.vue';
import AddRelationship from '../views/add/AddRelationship';
//const AddRelationship = () => import('../views/AddRelationship');
import UserInfo from '../views/profile/UserInfo.vue';
import AddRelationshipSuccess from '../views/add/AddRelationshipSuccess';
import RelationshipList from '../views/profile/RelationshipList';
import RelationshipDetail from '../views/profile/RelationshipDetail';
import MyFavorites from '../views/favorites/MyFavorites';
import History from '../views/history/History';
import SearchHome from '../views/search/SearchHome';
import OverView from '../views/overview/OverView';
import OrgDetail from '@components/content/org/OrgDetail';
import ListFundingNews from '@components/content/org/ListFundingNews';
import ListFunding from '@components/content/org/ListFunding';
import ListExitIPO from '@components/content/org/ListExitIPO';
import ListExitSales from '@components/content/org/ListExitSales';

import ContractorDetail from '@components/content/contractor/ContractorDetail';
import contractorDetailCompany from '@components/content/contractor/ContractorDetailCompany';

import NewsDetail from '../views/overview/NewsDetail';
import NewsMarket from '../views/overview/NewsMarket';
import Feedback from '../views/profile/Feedback';
import InvestedDetail from '@components/content/invested/InvestedDetail';
import Login from '../views/login/Login';

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home/overview'
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: { keepAlive: true },
            children: [
                {
                    path: 'overview',
                    name: 'OverView',
                    component: OverView,
                    meta: { keepAlive: true },
                },
                {
                    path: 'addRelationship',
                    name: 'AddRelationship',
                    component: AddRelationship
                },
                {
                    path: 'userInfo',
                    name: 'UserInfo',
                    component: UserInfo
                },
                {
                    path: 'searchHome',
                    name: 'SearchHome',
                    component: SearchHome,
                    meta: { keepAlive: true },
                },
                {
                    path: 'addSuccess',
                    name: 'AddSuccess',
                    component: AddRelationshipSuccess,
                },
                {
                    path: 'myRelationshipList/:random',
                    name: 'myRelationshipList',
                    component: RelationshipList,
                    meta: { keepAlive: true },
                },
                // {
                //     path: 'relationshipDetail',
                //     name:'RelationshipDetail',
                //     component:RelationshipDetail, 
                //     meta: { keepAlive: true },
                // },  
            ]
        },
        {
            path: '/relationshipDetail',
            name: 'RelationshipDetail',
            component: RelationshipDetail,
            meta: { keepAlive: true },
        },
        {
            path: '/orgDetail/:random',
            name: 'orgDetail',
            component: OrgDetail,
            meta: { keepAlive: true },
        },
        {
            path: '/contractorDetail',
            name: 'contractorDetail',
            component: ContractorDetail,
            //meta: { keepAlive: true },
        },
        {
            path: '/contractorDetailCompany',
            name: 'contractorDetailCompany',
            component: contractorDetailCompany,
            //meta: { keepAlive: true },
        },
        {
            path: '/listFundingNews/:random',
            name: 'listFundingNews',
            component: ListFundingNews,
            meta: { keepAlive: true },
        },
        {
            path: '/listFunding',
            name: 'listFunding',
            component: ListFunding,
            //meta: { keepAlive: true },
        },
        {
            path: '/listExitIPO',
            name: 'listExitIPO',
            component: ListExitIPO,
            //meta: { keepAlive: true },
        },
        {
            path: '/listExitSales',
            name: 'listExitSales',
            component: ListExitSales,
            //meta: { keepAlive: true },
        },
        {
            path: '/investedDetail/:random',
            name: 'investedDetail',
            component: InvestedDetail,
            meta: { keepAlive: true },
        },
        {
            path: '/myFavorites/:random',
            name: 'myFavorites',
            component: MyFavorites,
            meta: { keepAlive: true },
        },
        {
            path: '/findHistory/:random',
            name: 'findHistory',
            component: History,
            meta: {
                keepAlive: true
            },
        },
        {
            path: '/newsDetail',
            name: 'NewsDetail',
            component: NewsDetail,
            meta: { keepAlive: true },
        },
        {
            path: '/newsMarket',
            name: 'NewsMarket',
            component: NewsMarket,
        },
        {
            path: '/feedback',
            name: 'Feedback',
            component: Feedback,
        },
        {
            path: '*',
            name: '404',
            component: NotFound,
        }
    ],
});


// WEBPACK FOOTER //
// ./src/router/index.js